import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox, Stack } from '@ardoq/layout';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import type { Notifier } from '@ardoq/dropdown-menu';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoDateRangeTimeFieldsSelectedDoqProps = {
  doqType: DoqType;
  includeActions?: boolean;
  selectFieldAction?: Notifier;
  i18nLocale: I18nLocale;
};

const NoDateRangeTimeFieldsSelectedDoqBase = ({
  doqType,
  includeActions = true,
  selectFieldAction,
  i18nLocale,
}: NoDateRangeTimeFieldsSelectedDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noDateRangeTimeFieldsSelected.title',
          'There is nothing to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDateRangeTimeFieldsSelected.message1',
                'All date range or time fields are currently hidden.'
              )}
            </FlexBox>
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDateRangeTimeFieldsSelected.message2',
                'To show more data, select at least one date time or time range field.'
              )}
            </FlexBox>
          </Stack>
        }
        buttonLabel={
          includeActions
            ? t(
                i18nLocale,
                'tabview:graphViews.emptyState.noDateRangeTimeFieldsSelected.selectField',
                'Select field'
              )
            : undefined
        }
        onButtonClick={
          includeActions && selectFieldAction
            ? () => selectFieldAction.notify()
            : undefined
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoDateRangeTimeFieldsSelectedDoq = connect(
  NoDateRangeTimeFieldsSelectedDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
